import React from 'react';

const IconBurger = () => {
  return (
    <div>
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7597 2.2546C16.4404 1.91513 15.9255 1.91513 15.6062 2.2546L10.1906 8.01159C9.93646 8.28177 9.93646 8.71822 10.1906 8.98841L15.6062 14.7454C15.9255 15.0849 16.4404 15.0849 16.7597 14.7454C17.079 14.4059 17.079 13.8586 16.7597 13.5192L12.0414 8.49654L16.7662 3.47389C17.079 3.14135 17.079 2.58713 16.7597 2.2546Z"
          fill="#8E9FB9"
        />
        <path
          d="M8.75968 1.2546C8.44035 0.915135 7.92552 0.915135 7.60619 1.2546L2.19062 7.01159C1.93646 7.28177 1.93646 7.71822 2.19062 7.98841L7.60619 13.7454C7.92552 14.0849 8.44035 14.0849 8.75968 13.7454C9.07901 13.4059 9.07901 12.8586 8.75968 12.5192L4.04143 7.49654L8.7662 2.47389C9.07901 2.14135 9.07901 1.58713 8.75968 1.2546Z"
          fill="#8E9FB9"
        />
      </svg>
    </div>
  );
};

export default IconBurger;
